import _classCallCheck from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// Author: Mike Corrigan <corrigan@gmail.com>
//
// This class implements tremolo notation.
import { Vex } from './vex';
import { Modifier } from './modifier';
import { Glyph } from './glyph';
import { GraceNote } from './gracenote';
export var Tremolo = /*#__PURE__*/function (_Modifier) {
  _inherits(Tremolo, _Modifier);

  _createClass(Tremolo, null, [{
    key: "CATEGORY",
    get: function get() {
      return 'tremolo';
    }
  }, {
    key: "YOFFSETSTEMUP",
    get: function get() {
      return -9;
    }
  }, {
    key: "YOFFSETSTEMDOWN",
    get: function get() {
      return -21;
    }
  }, {
    key: "XOFFSETSTEMUP",
    get: function get() {
      return 6;
    }
  }, {
    key: "XOFFSETSTEMDOWN",
    get: function get() {
      return -2;
    }
  }]);

  function Tremolo(num) {
    var _this;

    _classCallCheck(this, Tremolo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tremolo).call(this));

    _this.setAttribute('type', 'Tremolo');

    _this.num = num;
    _this.note = null;
    _this.index = null;
    _this.position = Modifier.Position.CENTER;
    _this.code = 'v74';
    return _this;
  }

  _createClass(Tremolo, [{
    key: "getCategory",
    value: function getCategory() {
      return Tremolo.CATEGORY;
    }
  }, {
    key: "draw",
    value: function draw() {
      this.checkContext();

      if (!(this.note && this.index != null)) {
        throw new Vex.RERR('NoAttachedNote', "Can't draw Tremolo without a note and index.");
      }

      this.setRendered();
      var stemDirection = this.note.getStemDirection();
      this.y_spacing = 4 * stemDirection;
      var start = this.note.getModifierStartXY(this.position, this.index);
      var x = start.x;
      var y = this.note.stem.getExtents().topY;
      var scale = this.note.getCategory() === 'gracenotes' ? GraceNote.SCALE : 1;

      if (stemDirection < 0) {
        y += Tremolo.YOFFSETSTEMDOWN * scale;
      } else {
        y += Tremolo.YOFFSETSTEMUP * scale;
      }

      this.font = {
        family: 'Arial',
        size: 16 * scale,
        weight: ''
      };
      this.render_options = {
        font_scale: 35 * scale,
        stroke_px: 3,
        stroke_spacing: 10 * scale
      };
      x += stemDirection < 0 ? Tremolo.XOFFSETSTEMDOWN : Tremolo.XOFFSETSTEMUP;

      for (var i = 0; i < this.num; ++i) {
        Glyph.renderGlyph(this.context, x, y, this.render_options.font_scale, this.code);
        y += this.y_spacing;
      }
    }
  }]);

  return Tremolo;
}(Modifier);